
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"108","height":"123","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M82.076 18.291c.213 1.582 1.007 5.075 2.47 6.397 1.83 1.653 7.723 11.418 7.39 14.406-.074 2.078-1.293 6.371-5.584 6.916-2.219.973-7.65.991-11.631-6.715-.394.568-1.047 2.02-.506 3.287.676 1.583 2.43 5.777 3.388 6.528.958.752 9.277 12.514 7.635 16.735-.224 2.455-1.729 7.472-5.95 7.897-2.475.957-8.423.744-12.417-7.765-1.135-2.51-3.33-8.006-3.031-9.902-.34-.329-1.108-.56-1.458 1.147-.436 2.134 1.585 13.44 2.835 15.753 1.25 2.312 7.79 15.432 6.728 18.994-.087 1.872-.962 6.006-3.771 7.565-3.511 1.949-7.487 2.636-10.595.444-2.833-1.636-8.652-6.228-9.26-11.51-.165.17-.633 1.027-1.189 3.092-.695 2.58-6.952 16.862-15.251 15.052-3.715-.223-11.306-2.869-11.95-11.67-.256-3.462.063-11.337 3.377-15.149.107-.07.155-.268-.51-.494-.832-.28-7.313-2.83-8.275-7.362-.543-1.24-1.343-4.354-.204-6.877 1.423-3.155 5.49-5.38 9.38-5.917 3.89-.538 10.555-1.064 11.496-1.316.94-.252 11.605-1.849 15.225-4.331 1.035-.53 3.2-1.891 3.58-3.102-.726.11-2.385.412-3.206.733-1.027.4-9.965 2.796-14.312.683-2.04-.713-6.116-2.974-6.102-6.306-.404-1.824-.49-5.969 2.406-7.955 1.33-1.154 5.282-3.432 10.459-3.306 2.82.068 3.27.035 2.765-.028a937.66 937.66 0 00-2.444-.184c.933.056 2.022.13 2.444.184 3.876.297 8.99.71 9.682.852 1.067.218 4.979-.704 6.953-2.745-1.516-.014-4.668-.11-5.145-.386-.597-.345-7.25-2.596-6.635-6.416-.252-2.663.395-8.122 4.993-8.648 2.01-.497 7.237-1.31 12.07-.587 1.707.257 5.374.677 6.383.306 1.263-.464 1.286-.849 2.29-.865 1.003-.017 3.906.465 5.477 2.565z","fill":"#4F7EDD"}})])
          )
        }
      }
    